// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__30R_h","content":"RecentSearches_content__2ANdz"};